/**
 * common.js
 *
 * @description Contains the logic that is common to inputs that deal with collections.
 *
 */

import { Input } from './input'

import { toggle } from '@/libraries/util/array'

export const CollectionInput = {
  data () {
    return {
      allOptionsAreChecked: false,
    }
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    layout: {
      type: Object,
      default: () => {},
    },
    multiselect: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    /** Checks if the arrays are wrapped.
     * Generally, collection input options have 2d arrays, so we can display columns.
     **/
    optionsAreAlreadyWrapped () {
      return this.options.every(option => Array.isArray(option))
    },
    /** Returns an array of the options, unwrapped from their arrays */
    flatOptions () {
      let flatOptions = this.options
      if (this.optionsAreAlreadyWrapped) {
        flatOptions = [].concat.apply([], this.options)
      }
      return flatOptions
    },
    /** Ensures that the o,ptions passed in are wrapped in an array. */
    columnsFromOptions () {
      if (!this.options) {
        return undefined
      }

      if (this.optionsAreAlreadyWrapped) {
        return this.options
      }
      return [this.options]
    },
    classesForSelectField: function () {
      return 'ui dropdown ' + (this.multiselect ? '' : '')
    },
    /**
     * A direction to use to render the input.
     */
    renderingDirection () {
      if (!this.layout) {
        return 'column'
      }

      if (!this.layout.direction) {
        return 'column'
      }

      return this.layout.direction
    },
  },
  methods: {
    applyInitialValue () {
      if (this.initialValue) {
        this.setValue(this.initialValue)
        // console.log('The caller set an initial value.')
        return
      }

      if (this.multiselect) {
        // console.log('Setting initial value to array.')
        this.value = []
      } else {
        // console.log('Setting initial value to empty string.')
        this.value = ''
      }
    },
    mappedOptions: function (options) {
      const optionsArray = Array.from(options)
      const mapped = optionsArray.map(option => option.value)
      return mapped
    },
    setValue: function (value) {
      let output = value

      if (this.multiselect || this.type === 'checkbox') {
        if (Array.isArray(this.value)) {
          output = toggle(this.value, value)
        } else {
          output = [value]
        }
      }
      this.value = output
      this.allOptionsAreChecked = this.flatOptions.every(option => this.optionIsChecked(option))
      this.emitChange(output)
    },
    toggleAll: function () {
      if (this.allOptionsAreChecked) {
        this.value = []
        this.allOptionsAreChecked = false
      } else {
        this.value = this.flatOptions.map(option => option.value)
        this.allOptionsAreChecked = true
      }
      this.emitChange(this.value)
    },
    optionIsChecked (option) {
      if (!this.value || !Array.isArray(this.value)) {
        return false
      }
      const contains = this.value.includes(option.value)
      // console.log(this.value + ' contains ' + option.value + '? ' + contains)
      return contains
    },
  },
  mixins: [Input],
}
